// LIBRARY FOR COMMUNICATING WITH LOCAL ZEBRA PRINTERS
import axios from "axios";
import { formatPhoneNumber } from ".";
import { findLocation } from "../Components/ReactQuery/QueryLocations"
import dayjs from "dayjs"
import { AXIOS_API_INSTANCE, LONG_DATE_FORMAT, LONG_DAY_FORMAT } from "../Constants"
import BrowserPrint from 'browserprint-es'
import { send_authorized_request } from "../Constants/cognito";


export const generate_test_label = () => {
    const hello_world = `^^XA^FO50,50^ADN,36,20^FDHELLO WORLD^FS^XZ`
    return hello_world
}


export const generate_service_order_label = (serviceorder, locations) => {
    console.log(serviceorder)
    const customer_item = serviceorder.customer_item
    const customer = serviceorder.customer
    const qr_code = window.location.href
    const locationName = findLocation(locations, serviceorder.location_id)
    const transferlocationName = findLocation(locations, serviceorder.current_location_id)
    var purchaseInfo = ""
    //Check if its Purchase here Equipment.
    if (customer_item.purchased_from_us === true) {
        purchaseInfo += "Origin Retailer"
    }
    if (customer_item.purchase_date) {
        // Do not localize time because it is stored as a UTC date in the database, and in EST it will show as the previous day
        purchaseInfo += " P-Date:" + dayjs.utc(customer_item.purchase_date).format(LONG_DAY_FORMAT)
        console.log("Purchased date is set:", dayjs.utc(customer_item.purchase_date).format(LONG_DAY_FORMAT));
    }

    //Check for a Transfer
    var transferNote = ``
    if (serviceorder.current_location_id !== serviceorder.location_id) {
        transferNote = `^FO0,750^GB464,80,80^FS
                       ^CF0,35
                       ^FR^FB464,1,0,C^FO0,755^FD${transferlocationName.name}^FS
                       ^FR^FB464,1,0,C^FO0,785^FDTRANSFER TRANSFER^FS`
    }

    const service_order_label_template = `
    ^XA
    
    ^FX Top section with logo, name and address.
    ^FO0,0^GB464,30,30^FS
    ^CFB,18
    ^FR^FB464,1,0,C^FO1,5^FD${locationName.name}^FS

    ^CF0,45
    ^FO10,50^FDSO #${serviceorder.id}^FS
    ^CF0,25
    ^FO10,90^FDCheck-in: ${dayjs.utc(serviceorder.date_created).local().format(LONG_DATE_FORMAT)}^FS
    ^FO10,115^GB389,3,3^FS
    
    ^FX Second section with customer address and contact information.
    ^CF0,25
    ^FO10,140^FD${customer.name}^FS
    ^FO10,170^FD${customer.address_1} ${customer.address_2}^FS
    ^FO10,200^FD${customer.city}, ${customer.state} ${customer.zip}^FS
    ^FO10,230^FD${formatPhoneNumber(customer.phone)}^FS
    ^FO10,270^GB389,3,3^FS
    
    ^FX Third section with item in for service information.
    ^CF0,25
    ^FO10,290^FDManufacturer: ${customer_item.manufacturer}^FS
    ^FO10,320^FDModel: ${customer_item.model}^FS
    ^FO10,350^FDSerial: ${customer_item.identifier}^FS
    ^CF0,20
    ^FO10,380^FD${purchaseInfo}^FS
    
    ^CF0,25
    ^FO10,410^FDExtr: ${Object.values(customer_item.extra_attrs ?? []).join(', ').slice(0, 100)}^FS
    ^FB390,6
    ^FO10,450^FDNotes: ${serviceorder.customer_notes.slice(0, 280)}^FS
    
    ^FX Fourth section with qr code.
    ^FO10,590,2^BQN,2,5,H^FH\\^FDLA,${qr_code}^FS
    ^FO435,590,1^BY3^BCN,120,Y,N,N,A^FD${serviceorder.id}^FS
   
    ${transferNote}
    ^XZ
    `
    console.log(service_order_label_template)
    return service_order_label_template
}


//Look for Zebra Printer 
export const print_zebra_label_browserPrint = async (zpl, serialNumber, location_id ,success_callback, failure_callback, skip_cloud = false) => {
    let defaultDevice = null;

    BrowserPrint.getDefaultDevice(
        'printer',
        function (response) {
            //console.log('got default device', response);
            defaultDevice = response;
            defaultDevice.send(zpl)
            console.log(defaultDevice.getStatus)
            success_callback(response)
        },
        function (err) {
            //Fallback to Cloud
            console.log(err)
            if (!skip_cloud) {
                print_zebra_label_cloud(zpl, serialNumber, location_id, success_callback, failure_callback)
            } else {
                failure_callback(err)
            }
        }
    );

    //const device = await BrowserPrint.getDefaultDeviceAsync();
    //console.log(device)
    //console.log(localDevices)

    //const printer = new Printer(device);

    //device.send(zpl)
    //printer.print(zpl);
}

// deprecated
export const print_zebra_label_local = (zpl, ip_addr, success_callback, failure_callback) => {
    var url = "https://" + ip_addr + "/pstprnt";
    axios.post(url, zpl, {
        headers: {
            "Content-Type": "text/plain"
        },
        mode: 'no-cors'
    }).then((response) => {
        if (success_callback) {
            success_callback(response)
        }
    }).catch((error) => {
        console.log(error)
        if (failure_callback) {
            failure_callback(error)
        }
    })
}



// Call the SendFileToPrinter API to send the content as a file to the printer(s)
export const print_zebra_label_cloud = (zpl, serialNumber, location_id, success_callback, failure_callback) => {

    // let url = "https://api.zebra.com/v2/devices/printers/send";
    // //Production Endpoint ... 

    // var fd = new FormData();
    // fd.append("zpl_file", new Blob([zpl], { type: 'text/plain' })); // Create a blob as file to send.
    // fd.append("sn", serialNumber);

    // axios.post(url, fd, {
    //     headers: {
    //         "apikey": apiKey,
    //         "tenant": tenant,
    //         "Content-Type": "multipart/form-data"
    //     },
    // }).then((response) => {
    //     if (success_callback) {
    //         success_callback(response)
    //     }
    // }).catch((error) => {
    //     console.log(error)
    //     if (failure_callback) {
    //         failure_callback(error)
    //     }
    // })

    send_authorized_request(() =>
        AXIOS_API_INSTANCE.post(
            `locations/${location_id}/integrations/zebra/print`,
            { zpl: zpl, serial_number: serialNumber }
        ).then(() => {
            success_callback()
        }).catch((error) => {
            console.log(error)
            if (failure_callback) {
                failure_callback(error)
            }
        })
    )



}